import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import Button from "../../../../../../components/button";
import {connect} from "react-redux";
import {
	getSharingDetailsPopup, isSharing,
	share
} from '../../../../../../../actions/sharingDetailsActions';
import Icon from "../../../../../../components/icon";
import {labelStateUpdating, resetStates} from "../../../../../../../actions/contactsGroupItemActions";

class ConfirmSharingPopup extends Component {

    constructor(props){
        super(props);

        this.state = {
            isLoading: false
        };

        this.cancelShare = this.cancelShare.bind(this);
        this.confirmShare = this.confirmShare.bind(this);
    }

    cancelShare(){

        let {setGmailAddOnData = ""} = this.props;
        let setGmailAddonIncludesGmail = setGmailAddOnData.includes('gmail');
        if(setGmailAddonIncludesGmail){
            window.close();
        }

        this.props.getSharingDetailsPopup([]);

        /* To reset Add collaborators */
        this.props.resetStates();
	    this.props.isSharing(false);
        this.props.labelStateUpdating(null);
    }

    confirmShare(){
        this.setState({
            isLoading: true
        }, () => {
            this.props.share();
        });
    }

    render() {
        return (
            <div className="p-4">
                <h2 className="text-warning pr-5"><Icon className="mr-2" name="warning"/>{this.props.t("warning")}</h2>
                <p>{this.props.t("confirmSharingText1")}</p>
                <div className="text-right">
                    <Button className="btn-link" disabled={this.state.isLoading} onClick={this.cancelShare}>
                        {this.props.t("noText")}
                    </Button>
                    {
                        this.state.isLoading === false
                        ?
                            <Button className="btn-primary" onClick={this.confirmShare}>
                                {this.props.t("yesText")}
                            </Button>
                        :
                            <Button className="btn-primary" disabled={true}>
                                <Icon animated={'pulse'} name="spinner"/>
                            </Button>
                    }
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        share : (object) => {
            dispatch(share(object))
        },
        resetStates: (exception) => {
            dispatch(resetStates(exception))
        },
        labelStateUpdating : (labelId) => {
            dispatch(labelStateUpdating(labelId))
        },
	    isSharing : (boolean) => {
            dispatch(isSharing(boolean))
        }
    }
};

const mapStateToProps = (state) => ({
	setGmailAddOnData: state.profileReducer.setGmailAddOnData.checkGmailAddon,
});


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmSharingPopup));
